import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrmBoardColumnInterface, CrmBoardColumnMetadataInterface } from '@galaxy/crm/components/board';
import { GalaxyFilterInterface } from '@vendasta/galaxy/filter/chips';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { MatIcon } from '@angular/material/icon';
import { ValueSummary } from '../value-summary.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'crm-list-objects-board-column-header',
  templateUrl: './column-header.component.html',
  styleUrls: ['./column-header.component.scss'],
  imports: [CommonModule, GalaxyPipesModule, MatIcon, TranslateModule, MatTooltip],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListObjectsBoardColumnHeaderComponent {
  column = input<CrmBoardColumnInterface<GalaxyFilterInterface | undefined>>();
  metadata = input<CrmBoardColumnMetadataInterface | undefined>();
  summary = input<ValueSummary | undefined>();

  probability = computed(() => {
    const column = this.column();
    return Math.trunc(100 * (column?.probability || 0));
  });
  columnAmounts = computed(() => {
    const column = this.column();
    const summary = this.summary();
    if (!column || !summary) {
      return;
    }

    return summary.stages?.find((stage) => stage.stageId === column.id)?.amounts;
  });

  total = computed(() => this.columnAmounts()?.total);
  estimated = computed(() => this.columnAmounts()?.estimated);
}
